import { render, staticRenderFns } from "./assinatura.vue?vue&type=template&id=57cf0a00"
import script from "./assinatura.vue?vue&type=script&lang=js"
export * from "./assinatura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports